export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const ERROR = 'ERROR'
export const LOADING = 'LOADING'

export const VERIFY_EMAIL = 'VERIFY_EMAIL'

export const CHANGE_TAB = 'CHANGE_TAB'